import createReactComponent from '../createReactComponent';
import { IconNode } from '../types';

export const __iconNode: IconNode = [["path",{"d":"M14 9l3 5.063","key":"svg-0"}],["path",{"d":"M4 9l6 6","key":"svg-1"}],["path",{"d":"M4 15l6 -6","key":"svg-2"}],["path",{"d":"M20 9l-4.8 9","key":"svg-3"}]]

/**
 * IconMathXy
 * @preview ![img](data:image/svg+xml;base64,PHN2ZwogIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyIKICB3aWR0aD0iMjQiCiAgaGVpZ2h0PSIyNCIKICB2aWV3Qm94PSIwIDAgMjQgMjQiCiAgZmlsbD0ibm9uZSIKICBzdHJva2U9ImN1cnJlbnRDb2xvciIKICBzdHJva2Utd2lkdGg9IjIiCiAgc3Ryb2tlLWxpbmVjYXA9InJvdW5kIgogIHN0cm9rZS1saW5lam9pbj0icm91bmQiCiAgY2xhc3M9Imljb24gaWNvbi10YWJsZXIgaWNvbnMtdGFibGVyLW91dGxpbmUgaWNvbi10YWJsZXItbWF0aC14eSIKPgogIDxwYXRoIHN0cm9rZT0ibm9uZSIgZD0iTTAgMGgyNHYyNEgweiIgZmlsbD0ibm9uZSIgLz4KICA8cGF0aCBkPSJNMTQgOWwzIDUuMDYzIiAvPgogIDxwYXRoIGQ9Ik00IDlsNiA2IiAvPgogIDxwYXRoIGQ9Ik00IDE1bDYgLTYiIC8+CiAgPHBhdGggZD0iTTIwIDlsLTQuOCA5IiAvPgo8L3N2Zz4=) - https://tabler.io/icons/icon/math-xy
 * @see https://docs.tabler.io/icons/libraries/react - Documentation
 *
 */
const IconMathXy = createReactComponent('outline', 'math-xy', 'MathXy', __iconNode);

export default IconMathXy;